import { StyleSheet } from 'react-native';

import maxContainerWidthStyle from '../../../styles/max-container-width/max-container-width.style';
import {
  centeredBox,
  mediumPaddingHorizontalBox,
  smallMarginTopBox,
} from '../../view-style';

export default StyleSheet.create({
  container: {
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 'auto',
  },
  content: {
    ...maxContainerWidthStyle,
  },
  section: {
    flex: 1,
  },
  view: {
    display: 'flex',
    ...centeredBox,
    ...smallMarginTopBox,
    ...mediumPaddingHorizontalBox,
  },
  viewText: {
    display: 'flex',
    ...centeredBox,
    ...smallMarginTopBox,
  },
  card: {
    width: '100%',
  },
});
